export const environment = {
  version: '1.2.6',
  production: true,
  environment: 'production',
  apiURL: 'https://api.worldofsweets.co.uk/',
  apiVersion: 'v3',
  username: 'appuser@mailinator.com',
  password: 'Admin@123456',
  client_id: 'Qp3IFurNh9hKL9WcwSPTpDaKce1p6bwXrFGvFpjG',
  client_secret: 'bZ3s1CEFYweEaLXiy9CIU7nFYkRwodeLfQ2o5JwqD4DeeL4nwRnbcKahwJhHW4aRGdaiVrHhmbOnrcV2iWPgrwbOA1oamAjlQZ6DFHnVsJRedLR4vkFh9BNckCkQVFeD',
  profile_s3_path: 'https://d2fp78ar86jimk.cloudfront.net',
  s3_path: 'https://d2fp78ar86jimk.cloudfront.net',
  product_image_folder:'thumbnails',
  grant_type: 'password',
  address_lookup_key: 'YU99-UT62-RZ43-JH12',
  dropdown_limit: 100,
  magentoApiUrl:'https://api.worldofsweets.co.uk/',
  magentoApiVersion:'V1',
  page_size: 10,
  profileFolder:'ordering/profile-images/',
  product_listing_page_size: 15,
  cart_page_size: 20,
  cmsNavigationUrl:'https://retailers.worldofsweets.co.uk',
  graphcmsapiurl:'https://api-eu-central-1.graphcms.com/v2/cknrki1wfbcpo01wj1hxy2dmz/master',
  qraphapiToken:'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6ImdjbXMtbWFpbi1wcm9kdWN0aW9uIn0.eyJ2ZXJzaW9uIjozLCJpYXQiOjE2MTk0Mjk2NjksImF1ZCI6WyJodHRwczovL2FwaS1ldS1jZW50cmFsLTEuZ3JhcGhjbXMuY29tL3YyL2NrbnJraTF3ZmJjcG8wMXdqMWh4eTJkbXovbWFzdGVyIiwiaHR0cHM6Ly9tYW5hZ2VtZW50LW5leHQuZ3JhcGhjbXMuY29tIl0sImlzcyI6Imh0dHBzOi8vbWFuYWdlbWVudC5ncmFwaGNtcy5jb20vIiwic3ViIjoiYmIxN2ZlMTAtZjZhMS00NzQzLTk1NDItNGU2ODhjNmM2NjIyIiwianRpIjoiY2tueWVtMmlhajNnbzAxeXQ5d2tiN3BvOCJ9.NqVMQ_oKk01yXFvmc_MfcQKoBOEczIrdpcr78Y369AzyMI2lpaNg7sLmVw4QTdb1zafXopApj8ppJML_XFMOZIskR0QsFvKbeVD79DYL4SIrVjS5qoJdU20Lu0lrSdlBvAcDe2HstYU60LY_z9nqcpCgjbuCtOjyxXW7-SGXQVFifatfX3Efu3uGYiHgODGSyq0YSoAPJQY3xLL65DnxqKpXaJanNg055NXUqJFRXrCE0Z3o56BanAgaw1nbUUouhoaG8-i3H59-2bgDB7CgzxHOgkZzd8SUT5UdUD5jRLIRex9BRv2QzUnzVmqR1ASr8Dd1CyaropOLlqq9SZH9IDUWjJ0FXctswvOaMwK0xIrrGv1JnyzeBft2on2cR8t0Nrla-VMO6hqGv4ZLGLWzv7l-qr3je8QcjDnsd0ihR1hZvAG4Bn6gq9aaiADfmOGINLNv0e15nFS2imkVfmaNPlp6pTOk8a_C8G1a9psz7oXfsrN-htr3voSgXfTV0YHiaOx8UfxgvMJ3P_B-KBnYy4c-Pzo-qhN7aFMJi5lcjd9aNCi0r5kC1hb7BXV0TbzNCDxejP18TZXiIVmk4erGOt9GOuCw3BBkYuV51I-_pC6zseoF8gdvo36Dc4V2hXEWOkoZJqlJxye3kJUI0IJtpfGED9OS0sxOD83AMST57lc',
  domainName:'retailers.worldofsweets.co.uk',
  versionCheckURL:'https://retailers.worldofsweets.co.uk/version.json',
  ga:'G-4KPBJX3KPB',
  checkoutToken:"pk_3lg2knhw6vw5yvc2d5qua7qm5yd",
  wos_secret_key:'password@123',
  hashedSecretKey:'f38ecf5379324f565d0365be0547b42e',
  hashedIV:'186DE986FC69F8E4',
  recaptchaSecretKey:'6LfSQhgpAAAAALRRkxFYeW2au4QTcgRNw8Q5MXE4',
  recaptchasiteKey:'6LdbQhgpAAAAADf6eNk9-lcTKI8vUb3pSFU2PFOo',
  maintenanceMode:false,
  maintenanceCheckURL:'',
  maintenanceMessage:"We're performing scheduled maintenance to improve your browsing experience. During this time,salesrep.worldofsweets.co.uk will be unavailable. We expect everything to be back online by 09:00AM Friday morning.",
  orderInvoiceFolder:'orderinvoicepdf/',
  magentoS3Path:'https://d2fp78ar86jimk.cloudfront.net',
  branch_io_secret:'key_live_ivcTWEWsLm7DpIZoA6zV0jdnAwctYN61',
  surveyUrl:"https://survey.zohopublic.com/zs/1YCNKF"
}
